<template>
    <div class="body">
        <div class="search-box">
            <div>
                <span class="title">日期：</span>
                <el-date-picker
                    :clearable="false"
                    v-model="date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    @change="getUploadProgress"
                ></el-date-picker>
            </div>
            <div style="margin-left: 20px">
                <span class="title">任务类型：</span>
                <el-select
                    class="form-item"
                    clearable
                    v-model="tsk_type"
                    placeholder="请选择任务类型"
                    @change="getUploadProgress"
                >
                    <el-option
                        class="form-item form-input"
                        v-for="item in task_types"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <!--			<div>-->
            <!--				<el-button class="primary-btn" @click="reset()">重置</el-button>-->
            <!--				<el-button type="primary" @click="getData()">查询</el-button>-->
            <!--			</div>-->
        </div>

        <div class="container">
            <!-- 表单 -->
            <div class="table-cls">
                <el-table
                    :data="table_data"
                    border
                    fit
                    class="table"
                    :cell-style="{color:'#666666'}"
                    :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500}"
                >
                    <el-table-column property="task_name" label="任务名称" align="center"></el-table-column>
                    <el-table-column property="task_type" label="任务类型" align="center">
                        <div slot-scope="scope">
                            <div>{{task_type[scope.row.task_type]}}</div>
                        </div>
                    </el-table-column>
                    <el-table-column property="rate" label="任务进度" align="center">
                        <template slot-scope="scope">
                            <div class="accuracyn">
                                <div class="accuracy">
                                    <div
                                        class="accuracy-w"
                                        :style="{'width':parseInt(scope.row.rate)+'%','background':parseInt(scope.row.rate)>=80?'#45A5FF':parseInt(scope.row.rate)<60?'#FF4949':'#13CE66'}"
                                    ></div>
                                </div>
                                <div
                                    class="accuracy-data"
                                    :class="parseInt(scope.row.rate)>=80?'color-blue':parseInt(scope.row.rate)<60?'color-red':'color-green'"
                                >{{parseInt(scope.row.rate)}}%</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="org"
                        align="center"
                        label="所属院校"
                        v-if="accountOrg === '1'"
                    >
                        <template slot-scope="scope">{{org_list_hash[scope.row.org]}}</template>
                    </el-table-column>
                    <el-table-column property="add_time" label="创建时间" align="center"></el-table-column>
                    <el-table-column property="task_status" label="状态" align="center">
                        <div slot-scope="scope">
                            <div
                                :class="scope.row.task_status==0?'color-task0':scope.row.task_status==1?'color-task1':scope.row.task_status==2?'color-task4':scope.row.task_status==3?'color-task3':'color-task2'"
                            >{{task_states[scope.row.task_status]}}</div>
                        </div>
                    </el-table-column>
                    <el-table-column property="add_user" label="操作人" align="center"></el-table-column>
                    <el-table-column width="350" align="center" label="操作" fixed="right">
                        <div slot-scope="scope">
                            <el-button
                                v-show="scope.row.task_status === 1 || scope.row.task_status === 3 || scope.row.task_type === 5 || scope.row.task_type === 6 || scope.row.task_type === 0"
                                class="primary-btn"
                                style="margin-left: 16px"
                                @click="journal(scope.row.id)"
                            >查看日志</el-button>
                          <el-button v-if="scope.row.task_type === 1" class="primary-btn" style="margin-left: 16px" @click="downloadFile(scope.row.file_url)">下载</el-button>
                          <el-button
                                class="primary-btn"
                                @click="refresh(scope.row.id,scope.$index,scope.row.task_status,scope.row.task_type)"
                            >刷新</el-button>
                            <!--                        <el-button type="success" @click="getUploadProgress(null,scope.row.id,scope.$index)" plain>刷新</el-button>-->

                            <!--							<el-button class="primary-btn" style="margin-left: 16px" @click="journal(scope.row.id)">查看日志</el-button>-->

                            <el-button
                                type="danger"
                                style="margin-left: 16px"
                                @click="del(scope.row.id,scope.$index)"
                                :disabled="accountOrg != scope.row.org"
                            >删除</el-button>
                        </div>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="current_page"
                        :page-size="10"
                        :total="page_total"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
            </div>

            <!-- 弹出框 -->
            <el-dialog width="50%" title="日志" :visible.sync="journal_dialog" append-to-body
                       :close-on-click-modal='false' :close-on-press-escape='false'>
                <ol style="margin-left: 20px;font-size: 16px;line-height: 1.5em">
                    <li v-for="(item,index) in journal_list" :key="index">{{item}}</li>
                </ol>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { isBlank, isValidPhone } from '../../utils/util';
export default {
    name: 'UploadProgress',
    data() {
        return {
            // '校验中','校验失败','导入中','导入失败','导入完成'
            appoint_date: '',
            dialogVisible: false,
            // 表单数据
            table_data: [],
            //分页
            current_page: 1,
            page_size: 10,
            page_total: 0,
            //头部 日期  任务类型
            date: '',
            tsk_type: '',
            journal_dialog: false,
            journal_list: [],
            task_type: [],
            task_states: [],
            task_types: [],
            org_list_hash: [],
            accountOrg: -1
        };
    },
    created() {
        this.getUploadProgress();
        this.getTransition();
        this.getTblInfo();
        //获取当前账号的所属院校
        this.accountOrg = localStorage.getItem('org');
    },
    methods: {
            //下载文件
            downloadFile(url){
                if(url!={} && url!=null)
                    window.open(url)
                else
                    this.$message.error('导入未成功，没有文件！')
            },
        // 创建时间
        getCurrentdate() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            let currentdate = year + '-' + month + '-' + strDate;
            return currentdate;
        },
        getTblInfo() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [['org', 'org_name', 'academy_base_t']],
                state: 0
            }).then(res => {
                if (res.code === 200) {
                    this.org_list_hash = res.data[0][1];
                } else {
                    console.log(res.error);
                }
            });
        },
        //获取页面渲染数据
        getUploadProgress(date, id, index) {
            let url;
            if (!id && !date) {
                date = this.getCurrentdate();
                this.date = date;
                url = this.BASEURL + `/task/management?page=${this.current_page}&date=${date}&task_type=${this.tsk_type}`;
            } else if (index || index === 0) {
                url = this.BASEURL + `/task/management?page=${this.current_page}&date=${date}&id=${id}`;
            } else {
                // 如果日期为空的时候  日期选择清除的时候
                if (date == null) {
                    date = '';
                }
                url = this.BASEURL + `/task/management?page=${this.current_page}&date=${date}&task_type=${this.tsk_type}`;
                // 备注:url里的data不能加this.
            }
            this.$get(url).then(res => {
                if (res.code === 200) {
                    /*2020-08-27 JZ新增 防止刷新更改总条数*/
                    if (!id) {
                        this.page_total = res.total;
                    }
                    if (index || index === 0) {
                        let singe_data = res.data[0];
                        this.table_data[index] = singe_data;
                        this.$set(this.table_data, index, singe_data);
                    } else {
                        this.table_data = res.data;
                    }
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        // 刷新
        changeDate(date) {
            this.appoint_date = date;
            this.getUploadProgress(date);
        },
        // 添加
        handleCurrentChange(current_page) {
            this.current_page = current_page;
            if (!this.appoint_date) {
                this.appoint_date = this.getCurrentdate();
            }
            this.getUploadProgress(this.appoint_date);
        },
        // 查看日志按钮
        journal(id) {
            let url = this.BASEURL + `/task/comment/GET?id=${id}`;

            this.$get(url).then(res => {
                if (res.code === 200) {
                    this.journal_dialog = true;
                    this.journal_list = res.data;
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        // 删除
        del(id, index) {
            let url = this.BASEURL + `/task/management?id=${id}`;

            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // this.$message({
                    //     type: 'success',
                    //     message: '删除成功!'
                    // });
                    this.$del(url).then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.table_data.splice(index, 1);
                            this.page_total = this.page_total - 1;
                        } else {
                            this.$message.error(res.error);
                        }
                    });
                })
                .catch(() => {});
        },
        refresh(id, index, status,sty) {
            if(sty === 0){
                if(status==2){
                    this.getUploadProgress(null, id, index);
                    this.$message.success('导入刷新成功');
                }else{
                    if(status==0){
                       this.$message.warning('导入校验中');
                    }else if(status==1){
                      this.$message.error('导入检验失败');
                    }else if(status==3){
                        this.$message.error('当前任务导入发生错误,请联系管理员');
                    }else{
                   this.$message.success('导入已经完成，请查看信息');
                    }
                }
            }else if(sty === 1){
                if(status==2){
                    this.getUploadProgress(null, id, index);
                    this.$message.success('刷新成功');
                }else{
                    if(status==0){
                        this.getUploadProgress(null, id, index);
                        this.$message.warning('刷新成功');
                    }else if(status==1){
                        this.$message.error('导出检验失败');
                    }else if(status==3){
                        this.$message.error('导出检验失败');
                    }else{
                        this.$message.success('导出已经完成，请下载');
                    }
                }
            }else if(sty === 2){
                if(status==2){
                    this.getUploadProgress(null, id, index);
                    this.$message.success('上传刷新成功');
                }else{
                    if(status==0){
                       this.$message.warning('上传校验中');
                    }else if(status==1){
                      this.$message.error('上传检验失败');
                    }else if(status==3){
                        this.$message.error('当前任务上传发生错误,请联系管理员');
                    }else{
                   this.$message.success('上传已经完成，请查看信息');
                    }
                }
            }else if(sty === 3){
                if(status==2){
                    this.getUploadProgress(null, id, index);
                    this.$message.success('下载刷新成功');
                }else{
                    if(status==0){
                       this.$message.warning('下载校验中');
                    }else if(status==1){
                      this.$message.error('下载检验失败');
                    }else if(status==3){
                        this.$message.error('当前任务下载发生错误,请联系管理员');
                    }else{
                   this.$message.success('下载已经完成，请查看信息');
                    }
                }

            }else if(sty === 4){
                if(status==2){
                    this.getUploadProgress(null, id, index);
                    this.$message.success('发送通知刷新成功');
                }else{
                    if(status==0){
                       this.$message.warning('发送通知校验中');
                    }else if(status==1){
                      this.$message.error('发送通知检验失败');
                    }else if(status==3){
                        this.$message.error('当前任务发送通知发生错误,请联系管理员');
                    }else{
                   this.$message.success('发送通知已经完成，请查看信息');
                    }
                }
            }else if(sty === 5){
                if(status==2){
                    this.getUploadProgress(null, id, index);
                    this.$message.success('修改成绩刷新成功');

                }else{
                    if(status==0){
                       this.$message.warning('修改成绩校验中');
                    }else if(status==1){
                      this.$message.error('修改成绩检验失败');
                    }else if(status==3){
                        this.$message.error('当前任务修改成绩发生错误,请联系管理员');
                    }else{
                      this.$message.success('修改成绩已经完成，请查看信息');
                    }
                }

            }

        },
        // 转化值
        getTransition() {
            let data = ['task_type', 'task_status'];
            this.$post(this.BASEURL + '/assets/transition/GET', {
                key_list: data
            }).then(res => {
                if (res.code === 200) {
                    // 头部的下拉选项
                    this.task_types = res.data.task_type[0];
                    this.task_type = res.data.task_type[1];
                    this.task_states = res.data.task_status[1];
                } else {
                    console.log(res.error);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/* 新增 */
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}
/* 表单 */
.table-cls {
    text-align: center;
    width: 100%;
}
.primary-btn {
    border-color: #409eff;
    color: #409eff;
}
.search-box {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;
    .search-input {
        width: 240px;
        margin-right: 16px;
    }
    .title {
        font-size: $title-size;
        line-height: 15px;
        color: #333333;
    }
}

.table {
    width: 100%;
    font-size: 14px;
}

.input-search {
    text-align: left;
}

.accuracyn {
    display: flex;
    align-items: center;
}
.accuracy {
    width: 100px;
    height: 8px;
    background: #e2e2e2;
    border-radius: 4px;
    overflow: hidden;
}
.accuracy-w {
    width: 10%;
    height: 100%;

    border-radius: 4px;

    background: red;
}
.accuracy-data {
    font-size: 14px;
    flex-wrap: 700;
	margin-left: 11px;
	min-width: 60px;
}
</style>
